import React from "react";
import "./certificatecard.css";

function CertificateCard({ imgSrc, imgAltMessage, certificateDate, desc }) {
  return (
    <div className="certificatecards-container">
      <img src={imgSrc} alt={imgAltMessage} loading="lazy" decoding="async" />
      <div className="cert-date-content">
        <img src="/images/Group (2).svg" alt="" />
        <p className="certificate-date-text">{certificateDate}</p>
         <img src="/images/close-bird.svg" alt="" />
      </div>
      <p className="certificatecards-text">{desc}</p>
    </div>
  );
}

export default React.memo(CertificateCard);
